import queryString from 'query-string';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosClient from 'api/axiosClient';
import { setGlobalLoading } from 'app/commonRedux/appSlice';
import { notificationToast } from 'components/notificationToast';
import { actions } from './overtimeSlice';
import { Notification } from 'constants/notification';

export const createProject = createAsyncThunk(
  '/project/create',
  async (params: any, thunkApi: any) => {
    const { setErrorMessage } = actions;
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response = await axiosClient.post(`/project`, params?.body);
      response && params?.callBack();
      return response;
    } catch (error) {
      thunkApi.dispatch(setErrorMessage(error));
      //return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const getProjectList = createAsyncThunk('/project/get-list', async (_, thunkApi: any) => {
  try {
    const response = await axiosClient.get(`/project`);
    return response;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getHistoryProjectManageProjectDetail = createAsyncThunk(
  '/project/history/search',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/project/history/search?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getHistoryProjectManageUserDetail = createAsyncThunk(
  '/project-detail/history/search',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/project-detail/history/search?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getHistoryPlanProjectDetail = createAsyncThunk(
  '/overtime/request-approve/history/search',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/overtime/request-approve/history/search?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getHistoryPlanUserDetail = createAsyncThunk(
  '/overtime/user-request/history/search',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/overtime/user-request/history/search?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getProjectDetail = createAsyncThunk(
  '/project/get-detail',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(`project/${params?.projectCode}`);
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const editProject = createAsyncThunk('/project/edit', async (params: any, thunkApi: any) => {
  const { setErrorMessage } = actions;
  try {
    thunkApi.dispatch(setGlobalLoading({ loading: true }));
    const response = await axiosClient.put(`/project/${params?.projectCode}`, params?.body);
    response && params?.callBack();
    return response;
  } catch (error) {
    return thunkApi.dispatch(setErrorMessage(error));
  } finally {
    thunkApi.dispatch(setGlobalLoading({ loading: false }));
  }
});

export const deleteProject = createAsyncThunk(
  '/project/delete',
  async (params: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response = await axiosClient.delete(`/project/${params.projectCode}`);
      response && params?.callBack();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

//Overtime Request
export const getOtRequestHistoryProject = createAsyncThunk(
  '/overtime/request-approve/history',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.post(
        `/overtime/request-approve/history?id=${params?.projectCode}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getOtRequestHistoryUser = createAsyncThunk(
  '/overtime/user-request/history',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/overtime/user-request/history?id=${params?.projectCode}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getOtRequestList = createAsyncThunk(
  '/overtime/request-approve/user',
  async ({ userId, ...params }: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(`/overtime/request-approve/user/${userId}`, {
        params,
      });

      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getOtRequestForEdit = createAsyncThunk(
  '/overtime/request-approve/detail',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(`/overtime/request-approve/${params?.id}/detail`);
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const createOtRequest = createAsyncThunk(
  '/overtime/request-approve',
  async (params: any, thunkApi: any) => {
    const { setErrorMessage } = actions;
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response = await axiosClient.post(`/overtime/request-approve`, params?.body);
      response && params?.callBack();
      return response;
    } catch (error) {
      return thunkApi.dispatch(setErrorMessage(error));
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const editOtRequest = createAsyncThunk(
  '/overtime/request-approve',
  async (params: any, thunkApi: any) => {
    const { setErrorMessage } = actions;
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response = await axiosClient.put(
        `/overtime/request-approve/${params?.id}`,
        params?.body,
      );
      response && params?.callBack();
      return response;
    } catch (error) {
      return thunkApi.dispatch(setErrorMessage(error));
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const getProjectListCurrentUser = createAsyncThunk(
  '/project/user',
  async (params: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response = await axiosClient.get(
        `/project/user/${params?.id}?isProjectLeader=${Boolean(params?.isProjectLeader)}${
          params?.month && params?.year ? `&monthYear=${params?.year}-${params?.month}` : ''
        }`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const updateOvertimePayrunMonth = createAsyncThunk(
  '/timesheet/request-over-time/payrun-month/bulk-update',
  async (
    params: {
      overtimeIds: number[];
      payrunMonth: string;
      transferHours?: number;
      salaryCoefficient?: number | null;
      callBack?: any;
    },
    thunkApi: any,
  ) => {
    const { overtimeIds, payrunMonth, transferHours, salaryCoefficient, callBack } = params;
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));

      // Prepare the request body
      const requestBody: any = {
        overtimeIds,
        payrunMonth,
      };

      // Only include transferHours and salaryCoefficient if they are not null/undefined
      if (transferHours !== undefined && transferHours !== null) {
        requestBody.transferHours = transferHours;
      }

      if (salaryCoefficient !== undefined && salaryCoefficient !== null) {
        requestBody.salaryCoefficient = Number(salaryCoefficient);
      }

      // Retry mechanism for network failures
      let response;
      let lastError;
      const maxRetries = 3;

      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          response = await axiosClient.patch(
            '/timesheet/request-over-time/payrun-month/bulk-update',
            requestBody,
          );
          break; // Success, exit retry loop
        } catch (error) {
          lastError = error;

          // Don't retry for client errors (4xx)
          if (error?.response?.status >= 400 && error?.response?.status < 500) {
            throw error;
          }

          // Retry for server errors (5xx) or network errors
          if (attempt < maxRetries) {
            console.log(`Retry attempt ${attempt + 1}/${maxRetries} for bulk update`);
            await new Promise((resolve) => setTimeout(resolve, 1000 * attempt)); // Exponential backoff
          }
        }
      }

      if (!response) {
        throw lastError;
      }

      response && callBack && callBack();
      notificationToast(
        Notification.Type.Success,
        'Cập nhật tháng tính lương thành công',
        Notification.Duration._3s,
      );
      return response;
    } catch (error) {
      // Enhanced error handling
      const errorMessage =
        error?.response?.data?.message || error?.message || 'Cập nhật tháng tính lương thất bại';
      notificationToast(Notification.Type.Error, errorMessage, Notification.Duration._3s);
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

// export const updateAllOvertimePayrunMonth = createAsyncThunk(
//   '/timesheet/request-over-time/payrun-month/update-all',
//   async (params: { payrunMonth: string; callBack?: any }, thunkApi: any) => {
//     const { payrunMonth, callBack } = params;
//     try {
//       thunkApi.dispatch(setGlobalLoading({ loading: true }));
//       const response = await axiosClient.patch(`/timesheet/request-over-time/payrun-month/update-all`, {
//         payrunMonth,
//       });
//       response && callBack && callBack();
//       notificationToast(
//         Notification.Type.Success,
//         'Cập nhật tất cả tháng tính lương thành công',
//         Notification.Duration._3s,
//       );
//       return response;
//     } catch (error) {
//       notificationToast(
//         Notification.Type.Error,
//         'Cập nhật tất cả tháng tính lương thất bại',
//         Notification.Duration._3s,
//       );
//       return thunkApi.rejectWithValue(error);
//     } finally {
//       thunkApi.dispatch(setGlobalLoading({ loading: false }));
//     }
//   },
// );

export const updateSingleOvertimePayrunMonth = createAsyncThunk(
  '/timesheet/request-over-time/:id/payrun-month',
  async (
    params: {
      id: number;
      payrunMonth: string;
      transferHours?: number;
      salaryCoefficient?: number | null;
      callBack?: any;
    },
    thunkApi: any,
  ) => {
    const { id, payrunMonth, transferHours, salaryCoefficient, callBack } = params;

    // Log the parameters being sent to the API
    console.log('updateSingleOvertimePayrunMonth - API Request:', {
      id,
      payrunMonth,
      transferHours,
      salaryCoefficient,
      salaryCoefficientType: typeof salaryCoefficient,
    });

    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));

      // Prepare the request body
      const requestBody: any = {
        overtimeId: id,
        payrunMonth,
      };

      // Only include transferHours and salaryCoefficient if they are not null/undefined
      if (transferHours !== undefined && transferHours !== null) {
        requestBody.transferHours = transferHours;
      }

      if (salaryCoefficient !== undefined && salaryCoefficient !== null) {
        requestBody.salaryCoefficient = Number(salaryCoefficient);
      }

      console.log('updateSingleOvertimePayrunMonth - Request body:', requestBody);

      // Retry mechanism for network failures
      let response;
      let lastError;
      const maxRetries = 3;

      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          response = await axiosClient.patch(
            `/timesheet/request-over-time/${id}/payrun-month`,
            requestBody,
          );
          break; // Success, exit retry loop
        } catch (error) {
          lastError = error;

          // Don't retry for client errors (4xx)
          if (error?.response?.status >= 400 && error?.response?.status < 500) {
            throw error;
          }

          // Retry for server errors (5xx) or network errors
          if (attempt < maxRetries) {
            console.log(`Retry attempt ${attempt + 1}/${maxRetries} for single update`);
            await new Promise((resolve) => setTimeout(resolve, 1000 * attempt)); // Exponential backoff
          }
        }
      }

      if (!response) {
        throw lastError;
      }

      console.log('updateSingleOvertimePayrunMonth - API Response:', response);
      response && callBack && callBack();
      notificationToast(
        Notification.Type.Success,
        'Cập nhật tháng tính lương thành công',
        Notification.Duration._3s,
      );
      return response;
    } catch (error) {
      // Enhanced error handling
      const errorMessage =
        error?.response?.data?.message || error?.message || 'Cập nhật tháng tính lương thất bại';
      notificationToast(Notification.Type.Error, errorMessage, Notification.Duration._3s);
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const getOvertimeByPayrunMonth = createAsyncThunk(
  '/timesheet/request-over-time/by-payrun-month',
  async (
    params: {
      payrunMonth?: string;
      page?: number;
      pageSize?: number;
      fromMonth?: string;
      toMonth?: string;
    },
    thunkApi: any,
  ) => {
    const { payrunMonth = 'null', page = 1, pageSize = 10, fromMonth, toMonth } = params;
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));

      // Build query params for pagination and additional parameters
      const queryParams = new URLSearchParams();
      queryParams.append('page', page.toString());
      queryParams.append('pageSize', pageSize.toString());

      // Add range parameters if provided
      if (fromMonth) queryParams.append('fromMonth', fromMonth);
      if (toMonth) queryParams.append('toMonth', toMonth);

      const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';

      // The payrunMonth should be in the URL path, not query parameters
      const response = await axiosClient.get(
        `/timesheet/request-over-time/by-payrun-month/${payrunMonth}${queryString}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

//Overtime approve
export const getApproveOt = createAsyncThunk(
  'overtime/request-approve/search',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `overtime/request-approve/search?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const getUserApproveOt = createAsyncThunk(
  'overtime/user-request/search/user',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `/overtime/user-request/search/user?${queryString.stringify(params)}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const approveRejectRequestOt = createAsyncThunk(
  'overtime/request-approve/update/multi',
  async (params: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response = await axiosClient.put(`overtime/request-approve/update/multi`, params?.body);
      response && params?.callBack();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const getOvertimeType = createAsyncThunk(
  '/overtime/type/get',
  async (params: { data: any; callBack?: any }, thunkApi: any) => {
    const { data, callBack } = params;
    try {
      const response = await axiosClient.get(
        `/overtime/type?limit=${data.limit}&offset=${data.offset}&type=${data.type}&manageOvertime=${data.manageOvertime}`,
      );
      response && callBack && callBack(response.data);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

// Sửa hàm getOvertimeTypeForSalaryCoefficient
export const getOvertimeTypeForSalaryCoefficient = createAsyncThunk(
  '/overtime/type/salary-coefficient',
  async (params: { type: string; callBack?: any }, thunkApi: any) => {
    const { type, callBack } = params;
    try {
      const response = await axiosClient.get(
        `/overtime/type?limit=100&offset=1&type=${type}&manageOvertime=salaryCoefficient`,
      );
      response && callBack && callBack(response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching overtime type for salary coefficient:', error);
      return thunkApi.rejectWithValue(error);
    }
  },
);

// Sửa hàm getOvertimeAllType
export const getOvertimeAllType = createAsyncThunk(
  '/overtime/type/get-all-type',
  async (params: { data: any; callBack?: any }, thunkApi: any) => {
    const { data, callBack } = params;
    try {
      const response = await axiosClient.get(
        `/overtime/type?limit=100&offset=1&type=${data.type || ''}`,
      );
      response && callBack && callBack(response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching all overtime types:', error);
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const postOvertimeType = createAsyncThunk(
  '/overtime/type/post',
  async (params: { data: any; manageOvertime: string; callBack?: any }, thunkApi: any) => {
    const { data, manageOvertime, callBack } = params;
    const { setErrorMessage } = actions;
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response: any = await axiosClient.post(`/overtime/type`, data.body);
      response && callBack(response.data);
      thunkApi.dispatch(
        getOvertimeType({
          data: { type: data.body.name, limit: 10, offset: 1, manageOvertime: manageOvertime },
        }),
      );
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
      notificationToast(Notification.Type.Success, response.message, Notification.Duration._3s);
      return response;
    } catch (error) {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
      return thunkApi.dispatch(setErrorMessage(error));
    }
  },
);
export const updateTaxCoefficient = createAsyncThunk(
  '/overtime/type/post',
  async (params: { data: any; name: string; callBack?: any }, thunkApi: any) => {
    const { data, name, callBack } = params;
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response: any = await axiosClient.post(`/overtime/type/update-coefficient`, data);
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
      notificationToast(Notification.Type.Success, response.message, Notification.Duration._3s);
      thunkApi.dispatch(getOvertimeType({ data: { type: name, limit: 10, offset: 1 } }));
      response && callBack(response.data);
      return response.data;
    } catch (error) {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
      return thunkApi.rejectWithValue(error);
    }
  },
);
export const updateOvertimeType = createAsyncThunk(
  '/overtime/type/update',
  async (params: { data: any; callBack?: any }, thunkApi: any) => {
    const { data, callBack } = params;
    const { setErrorMessage } = actions;
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response: any = await axiosClient.put(`/overtime/type/${data.id}`, data.body);
      response && callBack(response.data);
      thunkApi.dispatch(getOvertimeType({ data: { type: data.body.name, limit: 10, offset: 1 } }));
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
      notificationToast(Notification.Type.Success, response.message, Notification.Duration._3s);
      return response;
    } catch (error) {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
      return thunkApi.dispatch(setErrorMessage(error));
    }
  },
);
export const updateCompensatoryConfiguration = createAsyncThunk(
  '/overtime/type/update',
  async (params: { data: any; manageOvertime: string; callBack?: any }, thunkApi: any) => {
    const { data, manageOvertime, callBack } = params;
    const { setErrorMessage } = actions;
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response: any = await axiosClient.put(`/overtime/type/${data.id}`, data.body);
      response && callBack(response.data);
      thunkApi.dispatch(
        getOvertimeType({
          data: { type: data.body.name, limit: 10, offset: 1, manageOvertime: manageOvertime },
        }),
      );
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
      notificationToast(Notification.Type.Success, response.message, Notification.Duration._3s);
      return response;
    } catch (error) {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
      return thunkApi.dispatch(setErrorMessage(error));
    }
  },
);
export const deleteOvertimeType = createAsyncThunk(
  '/overtime/type/delete',
  async (
    params: { id: number; name: string; manageOvertime: string; callBack?: any },
    thunkApi: any,
  ) => {
    const { id, name, manageOvertime, callBack } = params;
    try {
      const response: any = await axiosClient.delete(`/overtime/type/${id}`);
      thunkApi.dispatch(
        getOvertimeType({
          data: { type: name, limit: 10, offset: 1, manageOvertime: manageOvertime },
        }),
      );
      response && callBack && callBack(response.data);
      notificationToast(Notification.Type.Success, response.message, Notification.Duration._3s);
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);
export const getAllHistoryOtType = createAsyncThunk(
  '/overtime/type/history',
  async (params: { data: any; callBack?: any }, thunkApi: any) => {
    const { data, callBack } = params;
    try {
      const response = await axiosClient.get(
        `/overtime/type-history?limit=${data.limit}&offset=${data.offset}&search=${data.id}`,
      );
      response && callBack && callBack(response.data);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const exportByProject = createAsyncThunk(
  'overtime/export-project',
  async (params: { projectIds: any }, thunkApi: any) => {
    const { projectIds } = params;
    try {
      let str: any = `Overtime_Approval_By_Project.xlsx`;
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response: any = await axiosClient.post(
        `overtime/export-project`,
        { projectIds },
        { responseType: 'blob' },
      );
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', str);
      document.body.appendChild(link);
      link.click();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const exportByUser = createAsyncThunk(
  'overtime/export-overtime',
  async (params: { body: any }, thunkApi: any) => {
    const { body } = params;
    try {
      let str: any = `Overtime_Approval_By_User.xlsx`;
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response: any = await axiosClient.post(
        `overtime/export-overtime`,
        { ...body },
        { responseType: 'blob' },
      );
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', str);
      document.body.appendChild(link);
      link.click();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const exportByUserDetail = createAsyncThunk(
  'overtime/export-overtime/user-detail',
  async (params: { body: any }, thunkApi: any) => {
    const { body } = params;
    try {
      let str: any = `Overtime_Approval_By_User_Detail.xlsx`;
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response: any = await axiosClient.post(
        `overtime/export-overtime/user-detail`,
        { ...body },
        { responseType: 'blob' },
      );
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', str);
      document.body.appendChild(link);
      link.click();
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const getProjectByDate = createAsyncThunk(
  '/project/user/:userId/overtime-request-approve?dateRequest',
  async (params: any, thunkApi: any) => {
    try {
      const response = await axiosClient.get(
        `project/user/${params?.userId}/overtime-request-approve?dateRequest=${params?.dateRequest}`,
      );
      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  },
);

export const approveOtRequest = createAsyncThunk(
  '/overtime/request-approve/edit-approved',
  async (params: any, thunkApi: any) => {
    const { setErrorMessage } = actions;
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response = await axiosClient.put(
        `/overtime/request-approve/edit-approved/${params?.id}`,
        params?.body,
      );
      response && params?.callBack();
      return response;
    } catch (error) {
      return thunkApi.dispatch(setErrorMessage(error));
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

export const deleteRequestOt = createAsyncThunk(
  '/overtime/request-approve/delete',
  async (params: any, thunkApi: any) => {
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));
      const response = await axiosClient.delete(`/overtime/request-approve/${params.id}`);
      response && params?.callBack && params.callBack();
      notificationToast(
        Notification.Type.Success,
        'Xóa yêu cầu tăng ca thành công',
        Notification.Duration._3s,
      );
      return response;
    } catch (error) {
      notificationToast(
        Notification.Type.Error,
        'Xóa yêu cầu tăng ca thất bại',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);

// Get all overtime records for bulk forward
export const getAllOvertimeRecords = createAsyncThunk(
  '/timesheet/request-over-time',
  async (
    params: { page?: number; pageSize?: number; status?: string; payrunMonthIsNull?: boolean },
    thunkApi: any,
  ) => {
    try {
      thunkApi.dispatch(setGlobalLoading({ loading: true }));

      // Build query params
      const queryParams = new URLSearchParams();
      const page = params.page ?? 1;
      const pageSize = params.pageSize ?? 10;
      // Backend expects offset/limit
      queryParams.append('offset', page.toString());
      queryParams.append('limit', pageSize.toString());
      if (params.status) queryParams.append('status', params.status);
      if (params.payrunMonthIsNull) queryParams.append('payrunMonthIsNull', 'true');

      const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
      const response = await axiosClient.get(`/timesheet/request-over-time${queryString}`);

      // axiosClient returns response.data already; backend wraps in { data: { result, total, ... } }
      return response?.data?.result ?? response?.data ?? response;
    } catch (error) {
      notificationToast(
        Notification.Type.Error,
        'Lỗi khi lấy danh sách giờ làm thêm',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(error);
    } finally {
      thunkApi.dispatch(setGlobalLoading({ loading: false }));
    }
  },
);
